import { useState } from "react";

export default function EmployeeForm() {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    address: "",
    role: "",
    joiningDate: "",
    password:"",
  });

  const [permissions, setPermissions] = useState({
    view: false,
    add: false,
    edit: false,
    delete: false,
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handlePermission = (perm) => {
    setPermissions({ ...permissions, [perm]: !permissions[perm] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData, permissions);
  };

  return (
    <div className="w-full">
      
      {/* Card Container */}
      <div className="max-w-6xl mx-auto bg-white rounded-t-2xl shadow-lg p-6">
        
        {/* Title */}
        <h2 className="text-2xl font-bold mb-6">Add New Employee</h2>

        {/* FORM */}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
            
            <input type="text" name="firstName" placeholder="First Name"
              onChange={handleChange}
              className="input" />

            <input type="text" name="lastName" placeholder="Last Name"
              onChange={handleChange}
              className="input" />

            <input type="email" name="email" placeholder="Email"
              onChange={handleChange}
              className="input" />

            <input type="text" name="phone" placeholder="Phone"
              onChange={handleChange}
              className="input" />

            <input type="text" name="address" placeholder="Address"
              onChange={handleChange}
              className="input " />

            <select name="role" onChange={handleChange} className="input">
              <option value="">Select Role</option>
              <option>Admin</option>
              <option>Manager</option>
              <option>Staff</option>
            </select>

            <input type="date" name="joiningDate"
              onChange={handleChange}
              className="input" />

             <input type="password" name="password" placeholder="password"
              onChange={handleChange}
              className="input" />

          </div>

          {/* PERMISSIONS */}
          {/* <div className="mt-8">
            <h3 className="text-xl font-semibold mb-4">Permissions</h3>

            <div className="grid grid-cols-2 md:grid-cols-10 gap-4">
              
              {["view", "add", "edit", "delete"].map((perm) => (
                <div
                  key={perm}
                  onClick={() => handlePermission(perm)}
                  className={`cursor-pointer p-2 rounded-xl border text-center font-medium text-[12px] transition
                    ${
                      permissions[perm]
                        ? "bg-blue-500 text-white"
                        : "bg-gray-100 hover:bg-gray-200"
                    }`}
                >
                  {perm.toUpperCase()}
                </div>
              ))}

            </div>
          </div> */}

          {/* BUTTON */}
          {/* <div className="mt-8 flex justify-start">
            <button className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-2 rounded-xl hover:opacity-90">
              Save Employee
            </button>
          </div> */}

        </form>
      </div>

      {/* INPUT STYLE */}
      <style>
        {`
          .input {
            padding: 10px 12px;
            border-radius: 10px;
            border: 1px solid #ddd;
            outline: none;
            width: 100%;
          }
          .input:focus {
            border-color: black;
          }
        `}
      </style>

    </div>
  );
}